import * as Sentry from '@sentry/react';
import { PROD_ENVIRONMENT } from '@appscore/web-constants/environments';

let initialized = false;

const sentryHub = {
  init: ({ dsn, environment }) => {
    if (typeof window === 'undefined' || initialized) return;

    const isLive = environment === PROD_ENVIRONMENT;

    Sentry.init({
      dsn,
      environment,
      release: `${APP_NAME}@${APP_VERSION}`,
      tracesSampleRate: isLive ? 0.1 : 1,
      sampleRate: isLive ? 0.1 : 1,
      integrations: [
        Sentry.browserTracingIntegration({
          enableInp: true,
        }),
      ],
    });

    initialized = true;
  },
  captureMessage: (message) => {
    if (!initialized) return null;
    Sentry.captureMessage(message);
  },
  captureException: (ex) => {
    if (!initialized) return null;
    Sentry.captureException(ex);
  },
  setTag: (key, value) => {
    if (!initialized) return null;
    Sentry.setTag(key, value);
  },
  setUser: (user) => {
    if (!initialized) return null;
    Sentry.setUser(user);
  },
  withScope: (cb) => {
    if (!initialized) return null;
    Sentry.withScope(cb);
  },
  addNavigation: (to) => {
    if (!initialized) return null;
    Sentry.addBreadcrumb({ type: 'navigation', category: 'navigation', data: { to } });
  },
};

Object.freeze(sentryHub);

export { sentryHub };
